import { ReadonlyURLSearchParams } from 'next/navigation';
import { clientCookies } from '../cookies';
import {
  parseScaleoClickParams,
  type ScaleoClickParams,
} from '../sessionAttributionTracking/scaleoClickParams';
import {
  ATTRIBUTION_COOKIE_NAME,
  readSessionScaleoParams,
} from '../sessionAttributionTracking/sessionAttributionTracker';

export type UtmParams = {
  clkid: string;
  clktype: string;
  utm_campaign: string;
  utm_medium: string;
  utm_source: string;
  utm_content: string;
  utm_term: string;
  utm_channel: string;
  utm_strategy: string;
};

/**
 * Scaleo pair for the current visit: URL first, then the session attribution
 * record (CORE-4767). Reading the URL alone dropped the attribution as soon as
 * the visitor navigated away from the landing page, so an in-session car quote
 * reached Zoho unattributed.
 *
 * Call this only from event handlers — it touches cookies, so using it during
 * render would make the server and client output disagree.
 */
const getScaleoParams = (
  searchParams: ReadonlyURLSearchParams | null,
): ScaleoClickParams | null => {
  const fromUrl = searchParams
    ? parseScaleoClickParams(searchParams.toString()).params
    : null;
  if (fromUrl) return fromUrl;
  if (typeof window === 'undefined') return null;
  return readSessionScaleoParams(
    clientCookies().get(ATTRIBUTION_COOKIE_NAME)?.value,
  );
};

export const getUtmParams = (
  searchParams: ReadonlyURLSearchParams | null,
): UtmParams => {
  const scaleo = getScaleoParams(searchParams);

  return {
    clkid: scaleo?.clkid || '',
    clktype: scaleo?.clktype || '',
    utm_campaign: searchParams?.get('utm_campaign') || '',
    utm_medium: searchParams?.get('utm_medium') || '',
    utm_source: searchParams?.get('utm_source') || '',
    utm_content: searchParams?.get('utm_content') || '',
    utm_term: searchParams?.get('utm_term') || '',
    utm_channel: searchParams?.get('utm_channel') || '',
    utm_strategy: searchParams?.get('utm_strategy') || '',
  };
};
